var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.767 5.664v4.304l1.52.947c.04.011.127.012.167 0l6.544-4.364c0-.516-.487-.887-.762-.887h-7.47z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.768 11.573l1.387.943c.196.142.431 0 .431 0C16.352 12.658 23 8.29 23 8.29v7.91c0 .86-.557 1.222-1.184 1.222h-7.05l.002-5.849zM7.583 9.59c-.472 0-.85.22-1.127.658-.279.439-.418 1.02-.418 1.743 0 .733.14 1.313.418 1.74.278.427.643.64 1.094.64.465 0 .835-.208 1.107-.623.272-.415.41-.99.41-1.727 0-.768-.133-1.365-.398-1.792-.264-.427-.626-.64-1.086-.64z",
    fill: "#0072C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.479v16.836L13.95 23V1L1 3.479zm8.665 11.264c-.547.712-1.26 1.07-2.141 1.07-.858 0-1.556-.346-2.097-1.036-.54-.691-.81-1.59-.81-2.699 0-1.17.274-2.118.823-2.84.548-.724 1.275-1.086 2.18-1.086.855 0 1.547.346 2.074 1.038.528.693.792 1.605.792 2.738 0 1.164-.274 2.103-.82 2.815z",
    fill: "#0072C6"
  })));
}
export default SvgOutlook;